export default __webpack_public_path__ + "7e720337dd8c0f906779e9b1c61ae7de.svg";